import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class PhoneMaskProcessing extends InputMaskProcessingBase {
  protected allowedChars = '0123456789';
  protected fixedPosGroupingChars = ['(', , , , ')', ' ', , , , '-'];
  protected maxLength = 14;
}
